/**
 * Event product page — read-more toggle for long descriptions.
 */
class EventProductPage {
  constructor(root) {
    this.description = root.querySelector('[data-event-description]');
    this.descriptionContent = root.querySelector('[data-event-description-content]');
    this.readMoreBtn = root.querySelector('[data-event-read-more]');

    this._initReadMore();
  }

  _initReadMore() {
    if (!this.description || !this.descriptionContent || !this.readMoreBtn) return;

    const collapsedMax = 280;

    const checkOverflow = () => {
      const isExpanded = this.description.classList.contains('is-expanded');
      if (isExpanded) return;

      const needsToggle = this.descriptionContent.scrollHeight > collapsedMax;
      this.readMoreBtn.hidden = !needsToggle;
      this.description.classList.toggle('is-collapsible', needsToggle);
    };

    this.readMoreBtn.addEventListener('click', () => {
      const expanded = this.description.classList.toggle('is-expanded');
      this.readMoreBtn.textContent = expanded
        ? this.readMoreBtn.dataset.lessLabel
        : this.readMoreBtn.dataset.moreLabel;
      this.readMoreBtn.setAttribute('aria-expanded', String(expanded));
    });

    checkOverflow();
    window.addEventListener('resize', checkOverflow, { passive: true });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-event-product]').forEach((root) => {
    new EventProductPage(root);
  });
});
